import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, TextInput, Pressable, Icon2 } from '../lib/react-native-compat';
import { loadUserData, updateUserDataArray, fNum, pNum } from '../db/company';
import { projectCompleteAtom, jobUserDataAtom, jobCostDetailAtom, phasedForecastAtom, selectedJobAtom, selectedVersionAtom, isLiveVersionAtom, dataSourceVersionAtom, selectedVersionLockedAtom } from '../store/company';
import { useAtom } from 'jotai';
import moment from 'moment';
import xlsx from 'xlsx';

const LaborClassification = (a) => {
    const laborRef = useRef()
    if (a?.photo) {
        a.setJobRef(a.job, 'laborRatios', laborRef)
    }
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom)
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [jobCostDetail, setJobCostDetail] = useAtom(jobCostDetailAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom);
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom)
    const [phased, setPhased] = useAtom(phasedForecastAtom);
    const [currentAllInBurnRate, setCurrentAllInBurnRate] = useState()

    const [job, setJob] = useState()
    const [superSTHours, setSuperSTHours] = useState()
    const [superOTHours, setSuperOTHours] = useState()
    const [totalSuperHours, setTotalSuperHours] = useState()
    const [superST, setSuperST] = useState()
    const [superOT, setSuperOT] = useState()
    const [totalSuper, setTotalSuper] = useState()
    const [foremanTotalHours, setForemanTotalHours] = useState()
    const [craftsmanST, setCraftsmanST] = useState()
    const [craftsmanOT, setCraftsmanOT] = useState()
    const [totalCraftsman, setTotalCraftsman] = useState()
    const [craftsmanSTHours, setCraftsmanSTHours] = useState()
    const [craftsmanOTHours, setCraftsmanOTHours] = useState()
    const [totalCraftsmanHours, setTotalCraftsmanHours] = useState()
    const [countOfCraftsmanOnPD, setCountOfCraftsmanOnPD] = useState()
    const [totalCountOfCraftsman, setTotalCountOfCraftsman] = useState()
    const [equipment, setEquipment] = useState()
    const [smallTools, setSmallTools] = useState()
    const [totalLaborHours, setTotalLaborHours] = useState()
    const [totalLabor, setTotalLabor] = useState()

    const [superSTHoursMonth, setSuperSTHoursMonth] = useState()
    const [superOTHoursMonth, setSuperOTHoursMonth] = useState()
    const [totalSuperHoursMonth, setTotalSuperHoursMonth] = useState()
    const [superSTMonth, setSuperSTMonth] = useState()
    const [superOTMonth, setSuperOTMonth] = useState()
    const [totalSuperMonth, setTotalSuperMonth] = useState()
    const [foremanTotalHoursMonth, setForemanTotalHoursMonth] = useState()
    const [craftsmanSTMonth, setCraftsmanSTMonth] = useState()
    const [craftsmanOTMonth, setCraftsmanOTMonth] = useState()
    const [totalCraftsmanMonth, setTotalCraftsmanMonth] = useState()
    const [craftsmanSTHoursMonth, setCraftsmanSTHoursMonth] = useState()
    const [craftsmanOTHoursMonth, setCraftsmanOTHoursMonth] = useState()
    const [totalCraftsmanHoursMonth, setTotalCraftsmanHoursMonth] = useState()
    const [countOfCraftsmanOnPDMonth, setCountOfCraftsmanOnPDMonth] = useState()
    const [totalCountOfCraftsmanMonth, setTotalCountOfCraftsmanMonth] = useState()
    const [equipmentMonth, setEquipmentMonth] = useState()
    const [smallToolsMonth, setSmallToolsMonth] = useState()
    const [currentMonthName, setCurrentMonthName] = useState()
    const [currentMonthStartDate, setCurrentMonthStartDate] = useState()
    const [currentMonthEndDate, setCurrentMonthEndDate] = useState()
    const [totalLaborHoursMonth, setTotalLaborHoursMonth] = useState()
    const [totalLaborMonth, setTotalLaborMonth] = useState()

    const [superSTHoursUser, setSuperSTHoursUser] = useState()
    const [superOTHoursUser, setSuperOTHoursUser] = useState()
    const [totalSuperHoursUser, setTotalSuperHoursUser] = useState()
    const [superSTUser, setSuperSTUser] = useState()
    const [superOTUser, setSuperOTUser] = useState()
    const [totalSuperUser, setTotalSuperUser] = useState()
    const [foremanTotalHoursUser, setForemanTotalHoursUser] = useState()
    const [craftsmanSTUser, setCraftsmanSTUser] = useState()
    const [craftsmanOTUser, setCraftsmanOTUser] = useState()
    const [totalCraftsmanUser, setTotalCraftsmanUser] = useState()
    const [craftsmanSTHoursUser, setCraftsmanSTHoursUser] = useState()
    const [craftsmanOTHoursUser, setCraftsmanOTHoursUser] = useState()
    const [totalCraftsmanHoursUser, setTotalCraftsmanHoursUser] = useState()
    const [countOfCraftsmanOnPDUser, setCountOfCraftsmanOnPDUser] = useState()
    const [totalCountOfCraftsmanUser, setTotalCountOfCraftsmanUser] = useState()
    const [equipmentUser, setEquipmentUser] = useState()
    const [smallToolsUser, setSmallToolsUser] = useState()
    const [totalLaborHoursUser, setTotalLaborHoursUser] = useState()
    const [totalLaborUser, setTotalLaborUser] = useState()

    const [foremanCraftRatioJTD, setForemanCraftRatioJTD] = useState()
    const [foremanCraftRatioMTD, setForemanCraftRatioMTD] = useState()
    const [superCraftRatioJTD, setSuperCraftRatioJTD] = useState()
    const [superCraftRatioMTD, setSuperCraftRatioMTD] = useState()
    const [percentCraftOvertimeJTD, setPercentCraftOvertimeJTD] = useState()
    const [percentCraftOvertimeMTD, setPercentCraftOvertimeMTD] = useState()
    const [percentSuperOvertimeJTD, setPercentSuperOvertimeJTD] = useState()
    const [percentSuperOvertimeMTD, setPercentSuperOvertimeMTD] = useState()
    const [averageCraftBaseWageRate, setAverageCraftBaseWageRate] = useState()
    const [averageCraftBaseWageRateJTD, setAverageCraftBaseWageRateJTD] = useState()
    const [averageCraftBaseWageRateMTD, setAverageCraftBaseWageRateMTD] = useState()
    const [percentForemanOvertime, setPercentForemanOvertime] = useState()
    const [percentForemanOvertimeJTD, setPercentForemanOvertimeJTD] = useState()
    const [percentForemanOvertimeMTD, setPercentForemanOvertimeMTD] = useState()

    const [allInBurnRateUser, setAllInBurnRateUser] = useState()
    const [allInBurnRateEtc, setAllInBurnRateEtc] = useState()
    const [smallToolsPerCraftUser, setSmallToolsPerCraftUser] = useState()
    const [equipmentPerCraftUser, setEquipmentPerCraftUser] = useState()
    const [percentCraftPerDiemUser, setPercentCraftPerDiemUser] = useState()
    const [averageSupervisionBaseWageRateUser, setAverageSupervisionBaseWageRateUser] = useState()
    const [averageCraftBaseWageRateUser, setAverageCraftBaseWageRateUser] = useState()
    const [foremanCraftRatio, setForemanCraftRatio] = useState()
    const [superCraftRatio, setSuperCraftRatio] = useState()
    const [percentCraftOvertime, setPercentCraftOvertimeUser] = useState()
    const [percentSuperOvertime, setPercentSuperOvertimeUser] = useState()
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [laborRows, setLaborRows] = useState([])
    const [otherLaborRows, setOtherLaborRows] = useState([])
    //const [calledData, setCalledData] = useState(false)

    const [versionInfo, setVersionInfo] = useState({})

    const createExcel = () => {
        const interfaceList = []
        Object.keys(LaborInterface).forEach((key) => {
            interfaceList.push({ Labor_Classification_Description: key, Labor_Classification_Code: LaborInterface[key] })
        })

        console.log('creating excel', laborRows, otherLaborRows)
        const ws = xlsx.utils.json_to_sheet(interfaceList);
        const wb = xlsx.utils.book_new();
        const ws2 = xlsx.utils.json_to_sheet(jobCostDetail);
        const ws3 = xlsx.utils.json_to_sheet(otherLaborRows);
        xlsx.utils.book_append_sheet(wb, ws2, 'Cost Detail');
        //xlsx.utils.book_append_sheet(wb, ws3, 'Other Labor Detail');
        xlsx.utils.book_append_sheet(wb, ws, 'Labor Mapping');
        xlsx.writeFile(wb, 'labor-classification.xlsx');
    }

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID == selectedVersion))
    }, [versions]);

    useEffect(() => {
        console.log('versionInfo changed', versionInfo)
    }, [versionInfo]);


    const s = StyleSheet.create({
        container: {
            flexDirection: 'row',
            paddingBottom: 0,
            borderBottomWidth: 1,
            borderColor: '#F9F8FB'
        },
        span2S: {
            width: 300,
            alignItems: 'center',
            fontSize: 15,
            padding: 2
        },
        span2TS: {
            width: 300,
            alignItems: 'center',
            fontSize: 15,
            padding: 2,
            fontWeight: 700
        },
        span2: {
            width: 300,
            alignItems: 'center',
            fontSize: 18,
            padding: 2,
            textAlign: 'left',
            paddingRight: 10

        },
        span2T: {
            width: 300,
            alignItems: 'center',
            fontSize: 18,
            padding: 2,
            fontWeight: 700,
            textAlign: 'center',
            paddingRight: 10

        },
        span1: {
            width: 100,
            alignItems: 'center',
            fontSize: 18,
            padding: 2,
            textAlign: 'right'
        },
        span1R: {
            width: 100,
            alignItems: 'center',
            fontSize: 18,
            padding: 2,
            borderColor: 'grey',
            borderLeftWidth: 3,
            textAlign: 'right'
        },
        span1T: {
            width: 100,
            alignItems: 'center',
            fontSize: 18,
            padding: 2,
            fontWeight: 700,
            textAlign: 'center',
            paddingRight: 10

        },
    })

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion }).then((data) => {
                //console.log('user data', data?.data)
                setJobUserData(data?.data);
            })
        }
    }, [selectedJob, selectedVersion])

    useEffect(() => {
        //console.log('jobCostDetail a', jobCostDetail)
        calculateActualAmounts(jobCostDetail)
    }, [jobCostDetail, versionInfo])

    useEffect(() => {
        const cData = {}
        const laborValues = {}
        const equipmentValues = {}
        const phasedLabor = {}
        const phasedEquipment = {}
        //console.log('jobUserData a', jobUserData)
        if (jobUserData && jobUserData.length > 0) {

            jobUserData.forEach((item) => {
                if (item.Forecast_Tab == 'Labor Classification') {
                    switch (item.Forecast_Field_Name) {
                        case 'superSTHoursUser':
                            setSuperSTHoursUser(item.Forecast_Value)
                            break
                        case 'superOTHoursUser':
                            setSuperOTHoursUser(item.Forecast_Value)
                            break
                        case 'superSTUser':
                            setSuperSTUser(item.Forecast_Value)
                            break
                        case 'superOTUser':
                            setSuperOTUser(item.Forecast_Value)
                            break
                        case 'foremanTotalHoursUser':
                            setForemanTotalHoursUser(item.Forecast_Value)
                            break
                        case 'craftsmanSTUser':
                            setCraftsmanSTUser(item.Forecast_Value)
                            break
                        case 'craftsmanOTUser':
                            setCraftsmanOTUser(item.Forecast_Value)
                            break
                        case 'craftsmanSTHoursUser':
                            setCraftsmanSTHoursUser(item.Forecast_Value)
                            break
                        case 'craftsmanOTHoursUser':
                            setCraftsmanOTHoursUser(item.Forecast_Value)
                            break
                        case 'countOfCraftsmanOnPDUser':
                            setCountOfCraftsmanOnPDUser(item.Forecast_Value)
                            break
                        case 'totalCountOfCraftsmanUser':
                            setTotalCountOfCraftsmanUser(item.Forecast_Value)
                            break
                        case 'equipmentUser':
                            setEquipmentUser(item.Forecast_Value)
                            break
                        case 'smallToolsUser':
                            setSmallToolsUser(item.Forecast_Value)
                            break
                        case 'totalLaborHoursUser':
                            setTotalLaborHoursUser(item.Forecast_Value)
                            break
                        case 'totalLaborUser':
                            setTotalLaborUser(item.Forecast_Value)
                            break
                    }

                }

                // if (item?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                //     if (phasedEquipment[item?.Forecast_Row_ID]) {
                //         phasedEquipment[item?.Forecast_Row_ID][item.Forecast_Field_Name] = item.Forecast_Value
                //     } else {
                //         phasedEquipment[item?.Forecast_Row_ID] = {
                //             id: item?.Forecast_Row_ID,
                //             equipment: item.Equipment_Tier,
                //             [item.Forecast_Field_Name]: item.Forecast_Value
                //         }
                //     }
                // }

                if (item?.Forecast_Tab === 'Burn Tool Labor Phased') {
                    phasedLabor[item?.Forecast_Row_ID] = item
                }

                // if (item?.Forecast_Tab === 'Burn Tool Equipment') {
                //     if (equipmentValues[item?.Forecast_Row_ID]) {
                //         equipmentValues[item?.Forecast_Row_ID][item.Forecast_Field_Name] = item.Forecast_Value
                //     } else {
                //         equipmentValues[item?.Forecast_Row_ID] = {
                //             id: item?.Forecast_Row_ID,
                //             [item.Forecast_Field_Name]: item.Forecast_Value
                //         }
                //     }
                // }

                if (item?.Forecast_Tab === 'Burn Tool Labor') {
                    laborValues[item?.Forecast_Row_ID] = item
                }
            })

            let equipment = 0
            let labor = 0
            let equipmentHours = 0
            let laborHours = 0
            let equipmentPhased = 0
            let laborPhased = 0
            let equipmentPhasedHours = 0
            let laborPhasedHours = 0

            // Object.keys(equipmentValues).forEach((key) => {
            //     if (key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(projectComplete).endOf('week').isAfter(key)) {
            //         const row = equipmentValues[key]
            //         equipment = equipment + ((isNaN(pNum(row.burnPerHour)) ? 0 : pNum(row.burnPerHour)) * (isNaN(pNum(row.numOfWorkers)) ? 0 : pNum(row.numOfWorkers)) * (isNaN(pNum(row.hoursPerWeek)) ? 0 : pNum(row.hoursPerWeek)))
            //         equipmentHours = equipmentHours + (isNaN(pNum(row.hoursPerWeek)) ? 0 : pNum(row.hoursPerWeek))
            //     }
            // })

            Object.values(laborValues).forEach((row) => {
                const week = row.Forecast_Row_ID.split('*')[0]
                console.log(week, moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')), moment(projectComplete).isAfter(week))
                if (moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(projectComplete).isAfter(week)) {
                    labor = labor + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                    laborHours = laborHours + (!isNaN(pNum(row.Number_Hours)) && !isNaN(pNum(row.Number_Units)) ? pNum(row.Number_Hours) * pNum(row.Number_Units) : 0)
                }
            })

            Object.keys(phasedLabor).forEach((row) => {
                const weekRow = row.includes('=')
                const week = row.split('=')[1]
                const phase = row.split('=')[0]
                const phaseDetails = phase ? phasedLabor[phase] : {}
                const withinProject = moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(projectComplete).endOf('week'))
                const withinStartStop = true//moment(week).isAfter(moment(phaseDetails?.startDate).startOf('week')) && moment(week).isBefore(moment(phaseDetails?.endDate).endOf('week'))
                const h = phasedLabor[row]?.Number_Hours ? phasedLabor[row].Number_Hours : 0
                const bR = phasedLabor[row]?.Rate ? phasedLabor[row].Rate : 0
                const cS = phasedLabor[row] && phasedLabor[row]?.Number_Units ? phasedLabor[row].Number_Units : 0
                if (weekRow && phasedLabor[row] && h && bR && cS && withinProject && withinStartStop) {
                    laborPhased = laborPhased + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0)
                    laborPhasedHours = laborPhasedHours + (!isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(cS) : 0)
                }
            })

            // const equipmentRates = {}
            // Object.keys(phasedEquipment).forEach((row) => {
            //     if (phasedEquipment[row].weekPerUnit) {
            //         equipmentRates[phasedEquipment[row].equipment] = phasedEquipment[row].weekPerUnit
            //     }
            // })

            // Object.keys(phasedEquipment).sort().forEach((t) => {
            //     const r = phasedEquipment[t]
            //     const pC = projectComplete
            //     const v = versionInfo?.Version_Start_DateTime
            //     const w = t.split('*')[1]
            //     const rate = equipRates[r.equipment] ? equipRates[r.equipment] : equipmentRates[r.equipment] ? equipmentRates[r.equipment] : phasedEquipment[r.equipment]?.weekPerUnit ? phasedEquipment[r.equipment].weekPerUnit : 0
            //     const h = r?.estHours
            //     const n = r?.numberEquipment
            //     if (w && h && n && rate && moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week'))) {
            //         equipmentPhased = equipmentPhased + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)
            //         equipmentPhasedHours = equipmentPhasedHours + (isNaN(pNum(h)) && isNaN(pNum(n)) ? pNum(h) * pNum(n) : 0)
            //     }
            // })


            if (phased == 'phased') {
                console.log('phased labor etc', laborPhasedHours, laborPhased, phasedLabor)
                laborPhasedHours ? setAllInBurnRateEtc(divideTwoValues(laborPhased, laborPhasedHours)) : ''
            } else {
                console.log('labor etc', laborHours, labor, laborValues)
                laborHours ? setAllInBurnRateEtc(divideTwoValues(labor, laborHours)) : ''
            }
            //seth
        }
    }, [jobUserData])

    const saveObject = (fieldName, value) => {
        console.log('save object', fieldName, value)
        let data = {
            userId: '154045',
            userName: 'Seth Bailey',
            fieldName: fieldName,
            tab: "Labor Classification",
            rowId: 1,
            version: selectedVersion + '',
            value: value + '',
            id: selectedJob,
            lockedVersion: lockedVersion
        }
        console.log('saveValue', data)
        updateUserDataArray(data)
    }

    useEffect(() => {
        setTotalSuperHoursUser(sumTwoValues(superSTHoursUser, superOTHoursUser))
        const delayDebounceFn = setTimeout(() => {
            if (superSTHoursUser) {
                saveObject('superSTHoursUser', superSTHoursUser)
                setTotalSuperHoursUser(sumTwoValues(superSTHoursUser, superOTHoursUser))
            }
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [superSTHoursUser])

    useEffect(() => {
        setTotalSuperHoursUser(sumTwoValues(superSTHoursUser, superOTHoursUser))
        setPercentSuperOvertimeUser(percentDivide(superOTHoursUser, totalSuperHoursUser))
        const delayDebounceFn = setTimeout(() => {
            if (superOTHoursUser) {
                saveObject('superOTHoursUser', superOTHoursUser)
                setTotalSuperHoursUser(sumTwoValues(superSTHoursUser, superOTHoursUser))
            }
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [superOTHoursUser])

    useEffect(() => {
        setAverageSupervisionBaseWageRateUser(divideTwoValues(superST, totalSuperHoursUser))
        setPercentSuperOvertimeUser(percentDivide(superOTHoursUser, totalSuperHoursUser))
        setSuperCraftRatio(createRatio(totalCraftsmanHoursUser, totalSuperHoursUser))
    }, [totalSuperHoursUser, superST])

    useEffect(() => {
        setTotalSuperUser(sumTwoValues(superSTUser, superOTUser))
        const delayDebounceFn = setTimeout(() => {
            if (superSTUser)
                saveObject('superSTUser', superSTUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [superSTUser])

    useEffect(() => {
        setTotalSuperUser(sumTwoValues(superSTUser, superOTUser))
        const delayDebounceFn = setTimeout(() => {
            if (superOTUser)
                saveObject('superOTUser', superOTUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [superOTUser])

    useEffect(() => {
        setForemanCraftRatioJTD(createRatio(totalCraftsmanHoursUser, foremanTotalHoursUser))
        setForemanCraftRatio(createRatio(totalCraftsmanHoursMonth, foremanTotalHoursMonth))
        const delayDebounceFn = setTimeout(() => {
            if (foremanTotalHoursUser) {
                saveObject('foremanTotalHoursUser', foremanTotalHoursUser)
            }
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [foremanTotalHoursUser])

    useEffect(() => {
        setTotalCraftsmanUser(sumTwoValues(craftsmanSTUser, craftsmanOTUser))
        const delayDebounceFn = setTimeout(() => {
            if (craftsmanSTUser)
                saveObject('craftsmanSTUser', craftsmanSTUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [craftsmanSTUser])

    useEffect(() => {
        setTotalCraftsmanUser(sumTwoValues(craftsmanSTUser, craftsmanOTUser))
        const delayDebounceFn = setTimeout(() => {
            console.log('saving craftsmanOTUser', craftsmanOTUser)
            if (craftsmanOTUser)
                saveObject('craftsmanOTUser', craftsmanOTUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [craftsmanOTUser])

    useEffect(() => {
        //if(craftsmanSTHoursUser)
        setTotalCraftsmanHoursUser(sumTwoValues(craftsmanSTHoursUser, craftsmanOTHoursUser))
        setAverageCraftBaseWageRateUser(divideTwoValues(craftsmanST, craftsmanSTHoursUser))
        // const delayDebounceFn = setTimeout(() => {
        //     if(craftsmanSTHoursUser)
        //     saveObject('craftsmanSTHoursUser', craftsmanSTHoursUser)
        // }, 3000)

        // return () => clearTimeout(delayDebounceFn)
    }, [craftsmanSTHoursUser, craftsmanOTHoursUser, craftsmanST])


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (craftsmanSTHoursUser)
                saveObject('craftsmanSTHoursUser', craftsmanSTHoursUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [craftsmanSTHoursUser])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (craftsmanOTHoursUser)
                saveObject('craftsmanOTHoursUser', craftsmanOTHoursUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [craftsmanOTHoursUser])

    useEffect(() => {
        setEquipmentPerCraftUser(divideTwoValues(equipmentUser, totalCraftsmanHoursUser))
        //setAverageCraftBaseWageRateUser(divideTwoValues(totalCraftsmanUser, totalCraftsmanHoursUser))
        setPercentCraftOvertimeUser(percentDivide(craftsmanOTHoursUser, totalCraftsmanHoursUser))
        setForemanCraftRatio(createRatio(totalCraftsmanHoursUser, foremanTotalHoursUser))
        setSuperCraftRatio(createRatio(totalCraftsmanHoursUser, totalSuperHoursUser))
    }, [totalCraftsmanHoursUser])


    useEffect(() => {
        setPercentCraftPerDiemUser(percentDivide(countOfCraftsmanOnPDUser, totalCountOfCraftsmanUser))
        const delayDebounceFn = setTimeout(() => {
            if (countOfCraftsmanOnPDUser)
                saveObject('countOfCraftsmanOnPDUser', countOfCraftsmanOnPDUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [countOfCraftsmanOnPDUser])

    useEffect(() => {
        setPercentCraftPerDiemUser(percentDivide(countOfCraftsmanOnPDUser, totalCountOfCraftsmanUser))
        const delayDebounceFn = setTimeout(() => {
            if (totalCountOfCraftsmanUser)
                saveObject('totalCountOfCraftsmanUser', totalCountOfCraftsmanUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [totalCountOfCraftsmanUser])

    useEffect(() => {
        if (equipmentUser) {
            console.log('setting value', totalCraftsmanHoursUser, equipmentUser, divideTwoValues(equipmentUser, totalCraftsmanHoursUser))
            setEquipmentPerCraftUser(divideTwoValues(equipmentUser, totalCraftsmanHoursUser))
        }
        const delayDebounceFn = setTimeout(() => {
            if (equipmentUser)
                saveObject('equipmentUser', equipmentUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [equipmentUser])

    useEffect(() => {
        console.log('setting small tools', smallToolsUser, totalCraftsmanHoursUser, divideTwoValues(smallToolsUser, totalCraftsmanHoursUser))
        setSmallToolsPerCraftUser(divideTwoValues(smallToolsUser, totalCraftsmanHoursUser))
        const delayDebounceFn = setTimeout(() => {
            if (smallToolsUser)
                saveObject('smallToolsUser', smallToolsUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [smallToolsUser, totalCraftsmanHoursUser])

    useEffect(() => {
        if (totalLaborHoursUser) {
            setAllInBurnRateUser(divideTwoValues(totalLaborUser, totalLaborHoursUser))
        }
        const delayDebounceFn = setTimeout(() => {
            if (totalLaborHoursUser)
                saveObject('totalLaborHoursUser', totalLaborHoursUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [totalLaborHoursUser])

    useEffect(() => {
        if (totalLaborUser) {
            setAllInBurnRateUser(divideTwoValues(totalLaborUser, totalLaborHoursUser))
        }
        const delayDebounceFn = setTimeout(() => {
            if (totalLaborUser)
                saveObject('totalLaborUser', totalLaborUser)
        }, 3000)

        return () => clearTimeout(delayDebounceFn)
    }, [totalLaborUser])

    const calculateActualAmounts = (job) => {
        let smallToolsJTD = 0
        let equipmentJTD = 0
        let laborJTD = 0
        let laborHoursJTD = 0
        let smallToolsMTD = 0
        let equipmentMTD = 0
        let laborMTD = 0
        let laborHoursMTD = 0
        let craftsmanSTHours = 0
        let craftsmanOTHours = 0
        let foremanTotalHours = 0
        let superTotalHours = 0
        let superSTHours = 0
        let superOTHours = 0
        let superST = 0
        let superOT = 0
        let totalSuper = 0
        let craftsmanST = 0
        let craftsmanOT = 0
        let craftTotalHours = 0
        let craftTotal = 0
        const craftsman = {}
        const craftsmanMonth = {}
        const craftsmanPD = {}
        const craftsmanPDMonth = {}
        let craftsmanSTHoursMonth = 0
        let craftsmanOTHoursMonth = 0
        let craftsmanSTMonth = 0
        let craftsmanOTMonth = 0
        let superSTHoursMonth = 0
        let superOTHoursMonth = 0
        let superSTMonth = 0
        let superOTMonth = 0
        let craftTotalHoursMonth = 0
        let craftTotalMonth = 0
        let superTotalHoursMonth = 0
        let totalSuperMonth = 0
        let foremanTotalHoursMonth = 0

        const laborRows = []
        const otherLaborRows = []

        job?.forEach((row) => {
            if (row.Cost_Type_Code >= '50000' && row.Cost_Type_Code <= '60000') {
                if (LaborInterface[row.Labor_Classification_Description] == 'CRAFT') {
                    craftsman[row.Staff_ID] = true
                    if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                        craftsmanMonth[row.Staff_ID] = true
                    }
                }

                if (row.Cost_Type_Code >= '51100' && row.Cost_Type_Code <= '51799') {
                    if (row.Cost_Type_Code == '51500') {
                        if (LaborInterface[row.Labor_Classification_Description] == 'CRAFT') {
                            craftsmanPD[row.Staff_ID] = true
                            if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                craftsmanPDMonth[row.Staff_ID] = true
                            }
                        }
                    }

                    laborJTD = laborJTD + row.Job_Cost
                    laborHoursJTD = laborHoursJTD + row.Total_Hours
                    if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                        laborMTD = laborMTD + row.Job_Cost
                        laborHoursMTD = laborHoursMTD + row.Total_Hours
                    }

                    //51200,51100
                    if (row.Cost_Type_Code >= '51100' && row.Cost_Type_Code <= '51299' || row.Cost_Type_Code == '51500') {
                        if (LaborInterface[row.Labor_Classification_Description] == 'CRAFT') {
                            const r = JSON.parse(JSON.stringify(row))
                            r.laborType = 'CRAFT'
                            laborRows.push(r)
                            if (row.Cost_Type_Code_Description == 'Regular Time') {
                                craftsmanSTHours = craftsmanSTHours + row.Total_Hours
                                craftsmanST = craftsmanST + row.Job_Cost
                                if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                    craftsmanSTHoursMonth = craftsmanSTHoursMonth + row.Total_Hours
                                    craftsmanSTMonth = craftsmanSTMonth + row.Job_Cost
                                }
                            } else if (row.Cost_Type_Code_Description == 'Overtime') {
                                craftsmanOTHours = craftsmanOTHours + row.Total_Hours
                                craftsmanOT = craftsmanOT + row.Job_Cost
                                if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                    craftsmanOTHoursMonth = craftsmanOTHoursMonth + row.Total_Hours
                                    craftsmanOTMonth = craftsmanOTMonth + row.Job_Cost
                                }
                            }

                            craftTotalHours = craftTotalHours + row.Total_Hours
                            craftTotal = craftTotal + row.Job_Cost
                            if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                craftTotalHoursMonth = craftTotalHoursMonth + row.Total_Hours
                                craftTotalMonth = craftTotalMonth + row.Job_Cost
                            }
                        } else if (LaborInterface[row.Labor_Classification_Description] == 'FOREMAN') {
                            const r = JSON.parse(JSON.stringify(row))
                            r.laborType = 'FOREMAN'
                            laborRows.push(r)
                            if (row.Cost_Type_Code_Description == 'Regular Time') {
                                foremanTotalHours = foremanTotalHours + row.Total_Hours
                            } else if (row.Cost_Type_Code_Description == 'Overtime') {
                                foremanTotalHours = foremanTotalHours + row.Total_Hours
                            }
                            if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                foremanTotalHoursMonth = foremanTotalHoursMonth + row.Total_Hours
                            }
                        } else if (LaborInterface[row.Labor_Classification_Description] == 'SUPERINTENDENT') {
                            const r = JSON.parse(JSON.stringify(row))
                            r.laborType = 'SUPERINTENDENT'
                            laborRows.push(r)
                            if (row.Cost_Type_Code_Description == 'Regular Time') {
                                superSTHours = superSTHours + row.Total_Hours
                                superST = superST + row.Job_Cost
                                if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                    superSTHoursMonth = superSTHoursMonth + row.Total_Hours
                                    superSTMonth = superSTMonth + row.Job_Cost
                                }
                            } else if (row.Cost_Type_Code_Description == 'Overtime') {
                                superOTHours = superOTHours + row.Total_Hours
                                superOT = superOT + row.Job_Cost
                                if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                    superOTHoursMonth = superOTHoursMonth + row.Total_Hours
                                    superOTMonth = superOTMonth + row.Job_Cost
                                }
                            }
                            superTotalHours = superTotalHours + row.Total_Hours
                            totalSuper = totalSuper + row.Job_Cost
                            if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                                superTotalHoursMonth = superTotalHoursMonth + row.Total_Hours
                                totalSuperMonth = totalSuperMonth + row.Job_Cost
                            }
                            //this needs to be outside of this loop
                        } else {
                            otherLaborRows.push(row)
                        }
                    }
                } else {
                    otherLaborRows.push(row)
                }

                if (row.Cost_Type_Code >= '52100' && row.Cost_Type_Code <= '52200') {
                    equipmentJTD = equipmentJTD + row.Job_Cost
                    if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                        equipmentMTD = equipmentMTD + row.Job_Cost
                    }
                }

                if (row.Cost_Type_Code >= '53300' && row.Cost_Type_Code <= '53399') {
                    smallToolsJTD = smallToolsJTD + row.Job_Cost
                    if (moment(row.Consolidated_Date).add(12, 'hours').isSame(versionInfo?.Version_Start_DateTime, 'month')) {
                        smallToolsMTD = smallToolsMTD + row.Job_Cost
                    }
                }
            }
        })

        const cma = (s) => {
            return s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

        setEquipment(cma(pNum(equipmentJTD).toFixed()))
        setSmallTools(cma(pNum(smallToolsJTD).toFixed()))
        setTotalLabor(cma(pNum(laborJTD).toFixed()))
        setEquipmentMonth(cma(pNum(equipmentMTD).toFixed()))
        setSmallToolsMonth(cma(pNum(smallToolsMTD).toFixed()))
        setTotalLaborMonth(cma(pNum(laborMTD).toFixed()))
        setTotalLaborHours(pNum(laborHoursJTD).toFixed())
        setTotalLaborHoursMonth(pNum(laborHoursMTD).toFixed())
        setCraftsmanSTHours(pNum(craftsmanSTHours).toFixed())
        setCraftsmanOTHours(pNum(craftsmanOTHours).toFixed())
        setForemanTotalHours(pNum(foremanTotalHours).toFixed())
        setSuperSTHours(pNum(superSTHours).toFixed())
        setSuperOTHours(pNum(superOTHours).toFixed())
        setTotalSuperHours(pNum(superTotalHours).toFixed())
        setSuperST(cma(pNum(superST).toFixed()))
        setSuperOT(cma(pNum(superOT).toFixed()))
        setTotalSuper(cma(pNum(totalSuper).toFixed()))
        setCraftsmanST(cma(pNum(craftsmanST).toFixed()))
        setCraftsmanOT(cma(pNum(craftsmanOT).toFixed()))
        setTotalCraftsman(cma(pNum(craftTotal).toFixed()))
        setTotalCraftsmanHours(pNum(craftTotalHours).toFixed())
        setCountOfCraftsmanOnPD(Object.keys(craftsmanPD).length)
        setTotalCountOfCraftsman(Object.keys(craftsman).length)
        setCraftsmanSTHoursMonth(pNum(craftsmanSTHoursMonth).toFixed())
        setCraftsmanOTHoursMonth(pNum(craftsmanOTHoursMonth).toFixed())
        setCraftsmanSTMonth(cma(pNum(craftsmanSTMonth).toFixed()))
        setCraftsmanOTMonth(cma(pNum(craftsmanOTMonth).toFixed()))
        setForemanTotalHoursMonth(pNum(foremanTotalHoursMonth).toFixed())
        setSuperSTHoursMonth(pNum(superSTHoursMonth).toFixed())
        setSuperOTHoursMonth(pNum(superOTHoursMonth).toFixed())
        setSuperSTMonth(cma(pNum(superSTMonth).toFixed()))
        setSuperOTMonth(cma(pNum(superOTMonth).toFixed()))
        setTotalSuperHoursMonth(pNum(superTotalHoursMonth).toFixed())
        setTotalSuperMonth(cma(pNum(totalSuperMonth).toFixed()))
        setCountOfCraftsmanOnPDMonth(Object.keys(craftsmanPDMonth).length)
        setTotalCountOfCraftsmanMonth(Object.keys(craftsmanMonth).length)
        setTotalCraftsmanMonth(cma(pNum(craftTotalMonth).toFixed()))
        setTotalCraftsmanHoursMonth(pNum(craftTotalHoursMonth).toFixed())

        setForemanCraftRatioJTD(createRatio(craftTotalHours, foremanTotalHours))
        setForemanCraftRatioMTD(createRatio(craftTotalHoursMonth, foremanTotalHoursMonth))
        setSuperCraftRatioJTD(createRatio(superTotalHours, craftTotalHours))
        setSuperCraftRatioMTD(createRatio(superTotalHoursMonth, craftTotalHoursMonth))

        setLaborRows(laborRows)
        setOtherLaborRows(otherLaborRows)
    }

    const sumTwoValues = (a, b) => {
        if (!a) a = 0
        if (!b) b = 0
        return (pNum(a) + pNum(b)).toFixed(2)
    }

    const createRatio = (a, b) => {
        if (!a) a = 0
        if (!b) b = 0
        const den = pNum(a) / pNum(b)
        if (isNaN(den)) return '0:0'
        return '1:' + den.toFixed()
    }

    const divideTwoValues = (a, b) => {
        if (!a) a = 0
        if (!b) b = 0
        return (pNum(a) / pNum(b)).toFixed(2)
    }

    const percentDivide = (a, b) => {
        return (pNum(a) / pNum(b) * 100).toFixed(2)
    }

    return (
        <View style={{ marginLeft: 30, marginBottom: 200, justifyContent: 'flex-start' }}>
            <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={{ flexDirection: 'row' }}>
                    <View ref={laborRef} style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                        <View style={s.container}>
                            <Text style={s.span2T}>
                                Item
                            </Text>
                            <Text style={s.span1T}>
                                Plan
                            </Text>
                            <Text style={s.span1T}>
                                JTD
                            </Text>
                            <Text style={s.span1T}>
                                MTD
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Foreman : Craft Ratio
                            </Text>
                            <Text style={s.span1}>
                                {foremanCraftRatio}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHours != 0 ? createRatio(totalCraftsmanHours, foremanTotalHours) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {foremanTotalHoursMonth != 0 ? createRatio(totalCraftsmanHoursMonth, foremanTotalHoursMonth) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Superintendent : Craft Ratio
                            </Text>
                            <Text style={s.span1}>
                                {superCraftRatio}
                            </Text>
                            <Text style={s.span1}>
                                {totalSuperHours != 0 ? createRatio(totalCraftsmanHours, totalSuperHours) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalSuperHoursMonth != 0 ? createRatio(totalCraftsmanHoursMonth, totalSuperHoursMonth) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Percent Craft Overtime
                            </Text>
                            <Text style={s.span1}>
                                {percentCraftOvertime}%
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHours != 0 ? percentDivide(craftsmanOTHours, totalCraftsmanHours) + '%' : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHoursMonth != 0 ? percentDivide(craftsmanOTHoursMonth, totalCraftsmanHoursMonth) + '%' : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Percent Super Overtime
                            </Text>
                            <Text style={s.span1}>
                                {percentSuperOvertime}%
                            </Text>
                            <Text style={s.span1}>
                                {totalSuperHours != 0 ? percentDivide(superOTHours, totalSuperHours) + '%' : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalSuperHoursMonth != 0 ? percentDivide(superOTHoursMonth, totalSuperHoursMonth) + '%' : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Average Craft Base Wage Rate
                            </Text>
                            <Text style={s.span1}>
                                {craftsmanSTUser && craftsmanSTHoursUser ? fNum(pNum(craftsmanSTUser) / pNum(craftsmanSTHoursUser)) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {craftsmanSTHours != 0 ? fNum(pNum(craftsmanST) / pNum(craftsmanSTHours)) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {craftsmanSTHoursMonth != 0 ? fNum(pNum(craftsmanSTMonth) / pNum(craftsmanSTHoursMonth)) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Average Supervision Base Wage Rate
                            </Text>
                            <Text style={s.span1}>
                                {superSTUser && superSTHoursUser ? fNum(pNum(superSTUser) / pNum(superSTHoursUser)) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {superSTHours != 0 ? fNum(pNum(superST) / pNum(superSTHours)) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {superSTHoursMonth != 0 ? fNum(pNum(superSTMonth) / pNum(superSTHoursMonth)) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Percent Craft on Per Diem
                            </Text>
                            <Text style={s.span1}>
                                {percentCraftPerDiemUser}%
                            </Text>
                            <Text style={s.span1}>
                                {totalCountOfCraftsman != 0 ? fNum(percentDivide(countOfCraftsmanOnPD, totalCountOfCraftsman)) + '%' : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalCountOfCraftsmanMonth != 0 ? fNum(percentDivide(countOfCraftsmanOnPDMonth, totalCountOfCraftsmanMonth)) + '%' : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Equipment Cost per Craft hour
                            </Text>
                            <Text style={s.span1}>
                                {equipmentPerCraftUser}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHours != 0 ? divideTwoValues(equipment?.replace(',', ''), totalCraftsmanHours) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHoursMonth != 0 ? divideTwoValues(equipmentMonth?.replace(',', ''), totalCraftsmanHoursMonth) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                Small Tools & Consumables per Craft Hour
                            </Text>
                            <Text style={s.span1}>
                                {smallToolsPerCraftUser}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHours != 0 ? divideTwoValues(smallTools?.replace(',', ''), totalCraftsmanHours) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalCraftsmanHoursMonth != 0 ? divideTwoValues(smallToolsMonth?.replace(',', ''), totalCraftsmanHoursMonth) : ''}
                            </Text>
                        </View>
                        <View style={s.container}>
                            <Text style={s.span2}>
                                All-In Burn Rate (ST/OT/BD/BYOD/PD/TP/RR)
                            </Text>
                            <Text style={s.span1}>
                                {allInBurnRateUser}
                            </Text>
                            <Text style={s.span1}>
                                {totalLaborHours != 0 ? divideTwoValues(totalLabor?.replace(',', ''), totalLaborHours) : ''}
                            </Text>
                            <Text style={s.span1}>
                                {totalLaborHoursMonth != 0 ? divideTwoValues(totalLaborMonth?.replace(',', ''), totalLaborHoursMonth) : ''}
                            </Text>
                            {allInBurnRateEtc ? <Text style={[s.span1T, { marginLeft: 20, width: 'auto' }]}>
                                ETC
                            </Text> : null}
                            <Text style={[s.span1, { width: 'auto' }]}>
                                {allInBurnRateEtc}
                            </Text>
                        </View>
                    </View>
                </View>
                <View>
                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f8fafc',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 20
                        }}
                        onPress={createExcel}
                    >
                        <Text style={{ color: '#334155', fontWeight: '500', fontSize: 14 }}>Export Excel</Text>
                    </Pressable>
                </View>
            </View>
            <View style={{ flexDirection: 'row' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, marginTop: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                    <View style={s.container}>
                        <Text style={s.span2T}>
                            Data Needed
                        </Text>
                        <Text style={s.span1T}>
                            Plan
                        </Text>
                        <Text style={s.span1T}>
                            Actual Data
                        </Text>
                        <Text style={s.span1T}>
                            Cur Month
                        </Text>
                        <Text style={s.span2T}>
                            Classification
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Super ST Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(superSTHoursUser), 1)}
                            onChangeText={setSuperSTHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(superSTHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(superSTHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Super OT Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(superOTHoursUser), 1)}
                            onChangeText={setSuperOTHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(superOTHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(superOTHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Super Hours
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuperHoursUser), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuperHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuperHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Super ST
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(superSTUser), 1)}
                            onChangeText={setSuperSTUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(superST), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(superSTMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Super OT
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(superOTUser), 1)}
                            onChangeText={setSuperOTUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(superOT), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(superOTMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Super
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuperUser), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuper), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalSuperMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            SUPERINTENDENT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Foreman Total Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(foremanTotalHoursUser), 1)}
                            onChangeText={setForemanTotalHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(foremanTotalHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(foremanTotalHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            FOREMAN
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Craftsman ST
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(craftsmanSTUser), 1)}
                            onChangeText={setCraftsmanSTUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanST), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanSTMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Craftsman OT
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(craftsmanOTUser), 1)}
                            onChangeText={setCraftsmanOTUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanOT), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanOTMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Craftsman
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsmanUser), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsman), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsmanMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Craftsman ST Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(craftsmanSTHoursUser), 1)}
                            onChangeText={setCraftsmanSTHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanSTHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanSTHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Craftsman OT Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(craftsmanOTHoursUser), 1)}
                            onChangeText={setCraftsmanOTHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanOTHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(craftsmanOTHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Craftsman Hours
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsmanHoursUser), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsmanHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCraftsmanHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Count of Craftsman on PD
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(countOfCraftsmanOnPDUser), 1)}
                            onChangeText={setCountOfCraftsmanOnPDUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(countOfCraftsmanOnPD), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(countOfCraftsmanOnPDMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Count of Craftsman
                        </Text>
                        <TextInput style={s.span1R}

                            value={fNum(pNum(totalCountOfCraftsmanUser), 1)}
                            onChangeText={setTotalCountOfCraftsmanUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCountOfCraftsman), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalCountOfCraftsmanMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            CRAFT
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Equipment
                        </Text>
                        <TextInput style={s.span1R}

                            value={fNum(pNum(equipmentUser), 1)}
                            onChangeText={setEquipmentUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(equipment), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(equipmentMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            52200, 52100
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Small Tools
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(smallToolsUser), 1)}
                            onChangeText={setSmallToolsUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(smallTools), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(smallToolsMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                            53300
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Labor Hours
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(totalLaborHoursUser), 1)}
                            onChangeText={setTotalLaborHoursUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(totalLaborHours), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalLaborHoursMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                        </Text>
                    </View>
                    <View style={s.container}>
                        <Text style={s.span2}>
                            Total Labor
                        </Text>
                        <TextInput style={s.span1R}
                            value={fNum(pNum(totalLaborUser), 1)}
                            onChangeText={setTotalLaborUser}
                        >
                        </TextInput>
                        <Text style={s.span1}>
                            {fNum(pNum(totalLabor), 1)}
                        </Text>
                        <Text style={s.span1}>
                            {fNum(pNum(totalLaborMonth), 1)}
                        </Text>
                        <Text style={s.span2}>
                        </Text>
                    </View>
                </View>
            </View>
        </View>
    );
};

export default LaborClassification;

export const LaborInterface = {
    "Employee_Title": "New_Title",
    "Assistant Division Manager": "MANAGEMENT",
    "Assistant Project Manager": "MANAGEMENT",
    "Assistant Superintendent": "SUPERINTENDENT",
    "Assistant Superintendent (S)": "SUPERINTENDENT",
    "Bending Engineer": "ENGINEER",
    "Bid Controls Specialist": "ESTIMATION",
    "Blaster": "CRAFT",
    "Business Development Director": "BD",
    "Carpenter": "CRAFT",
    "Civil Designer": "ENGINEER",
    "Civil General Superintendent": "SUPERINTENDENT",
    "Clerk": "ADMIN",
    "Common Labor": "CRAFT",
    "Construction Manager": "CM",
    "Craft Helper": "CRAFT",
    "Craftsman": "CRAFT",
    "Crane Operator": "CRAFT",
    "Designer": "ENGINEER",
    "Director": "MANAGEMENT",
    "Director & Gen. Manager, Delta": "MANAGEMENT",
    "Director of Operations, WTX": "MANAGEMENT",
    "Director of Quality Management": "MANAGEMENT",
    "Director, Alternative Energy": "MANAGEMENT",
    "Director, Bolt": "MANAGEMENT",
    "Director, Bolt I&E Services": "MANAGEMENT",
    "Director, Capital Facilities": "MANAGEMENT",
    "Director, Delta Directional": "MANAGEMENT",
    "Director, EPC Services": "MANAGEMENT",
    "Director, East Texas": "MANAGEMENT",
    "Director, Gen Manager, Pickett": "MANAGEMENT",
    "Director, Gulf Coast Region": "MANAGEMENT",
    "Director, HSE": "MANAGEMENT",
    "Director, Midcon Region": "MANAGEMENT",
    "Director, Northern Region": "MANAGEMENT",
    "Director, Pipeline Services": "MANAGEMENT",
    "Director, Project Estimating": "MANAGEMENT",
    "Director, Project Controls": "MANAGEMENT",
    "Director, South Texas": "MANAGEMENT",
    "Director, Southeastern Region": "MANAGEMENT",
    "Division Manager": "MANAGEMENT",
    "Document Controls Specialist": "ADMIN",
    "Draftsman": "ENGINEER",
    "Driller": "CRAFT",
    "EHS Specialist": "HSE",
    "EPC Project Specialist": "ADMIN",
    "Electrical Asst Superintendent": "SUPERINTENDENT",
    "Electrical Engineer": "ENGINEER",
    "Electrical Foreman": "FOREMAN",
    "Electrical General Foreman": "FOREMAN",
    "Electrical Journeyman 1": "CRAFT",
    "Electrical Journeyman 2": "CRAFT",
    "Electrical Superintendent": "SUPERINTENDENT",
    "Engineering Manager": "ENGINEER",
    "Engineering Specialist": "ENGINEER",
    "Equipment Operator": "CRAFT",
    "Estimating Manager": "ESTIMATION",
    "Executive Assistant": "ADMIN",
    "Fiber Division Administrator": "ADMIN",
    "Fiber Foreman": "FOREMAN",
    "Fleet Logistic Manager": "MANAGEMENT",
    "Fleet Manager": "MANAGEMENT",
    "Foreman": "FOREMAN",
    "Foreman (Hourly)": "FOREMAN",
    "Foreman (Salary)": "FOREMAN",
    "Foreman - Welding (w/o Rig)": "FOREMAN",
    "General Foreman": "FOREMAN",
    "General Foreman (Hourly)": "FOREMAN",
    "General Foreman (Salary)": "FOREMAN",
    "General Manager": "CM",
    "General Superintendent": "SUPERINTENDENT",
    "General Superintendent (H)": "SUPERINTENDENT",
    "General Superintendent (S)": "SUPERINTENDENT",
    "HSE & OQ Specialist": "HSE",
    "HSE & OQ Specialist 1": "HSE",
    "HSE & OQ Specialist 2": "HSE",
    "HSE Administrator": "HSE",
    "HSE Assistant": "HSE",
    "HSE Manager": "HSE",
    "HSE Specialist": "HSE",
    "HSE Specialist 1": "HSE",
    "HSE Specialist 2": "HSE",
    "HSE Specialist 3": "HSE",
    "HSE Trainer": "HSE",
    "I&C Commissioning Technician": "CRAFT",
    "I&E Construction Manager": "CM",
    "I&E Designer": "ENGINEER",
    "I&E Foreman": "FOREMAN",
    "I&E Project Manager": "PM",
    "I&E Superintendent": "SUPERINTENDENT",
    "IE Apprentice (1st Year)": "CRAFT",
    "IE Apprentice (2nd Year)": "CRAFT",
    "IE Apprentice (3rd Year)": "CRAFT",
    "IE Apprentice (4th Year)": "CRAFT",
    "IE Apprentice (5th Year)": "CRAFT",
    "Instrument Fitter": "CRAFT",
    "Instrument Technician": "CRAFT",
    "Intern": "CRAFT",
    "Journeyman": "CRAFT",
    "Journeymen Electrician": "CRAFT",
    "Junior Surveyor": "CRAFT",
    "Lead I&C Automation Engineer": "ENGINEER",
    "Lead Instrumentation Engineer": "ENGINEER",
    "Lead Mechanical Drafter": "ENGINEER",
    "Lead Structural Engineer": "ENGINEER",
    "Licensed Operator": "CRAFT",
    "Line Locator": "CRAFT",
    "Logistic Manager": "LOGISTICS",
    "Manager": "ADMIN",
    "Material Buyer/Expeditor": "PROCUREMENT",
    "Mechanic": "CRAFT",
    "Mechanic Helper": "CRAFT",
    "Mechanic Manager": "CRAFT",
    "Mechanical Drafter": "ENGINEER",
    "Mechanical Drafting Lead": "ENGINEER",
    "Mechanical Engineer": "ENGINEER",
    "Office Manager": "ADMIN",
    "Office Manager (Hourly)": "ADMIN",
    "Operator": "CRAFT",
    "OPERATOR I (Steward)": "CRAFT",
    "Operator Helper": "CRAFT",
    "Operations Manager": "MANAGEMENT",
    "Operations Manager, EPC": "MANAGEMENT",
    "Operations Supervisor": "CRAFT",
    "Painter": "CRAFT",
    "Payroll Manager": "ADMIN",
    "Pipe Fitter": "CRAFT",
    "Plant Manager": "MANAGEMENT",
    "Process Engineer": "ENGINEER",
    "Procurement Manager": "PROCUREMENT",
    "Procurement Specialist": "PROCUREMENT",
    "Production Manager": "MANAGEMENT",
    "Program Manager": "PM",
    "Project Admin Support": "ADMIN",
    "Project Controls Manager": "PM",
    "Project Controls Specialist": "PM",
    "Project Coordination Manager": "PROJECT COORDINATOR",
    "Project Coordinator": "PROJECT COORDINATOR",
    "Project Coordinator (Hourly)": "PROJECT COORDINATOR",
    "Project Coordinator (Salary)": "PROJECT COORDINATOR",
    "Project Engineer": "ENGINEER",
    "Project Estimator": "ESTIMATION",
    "Project Estimator, I&E": "ESTIMATION",
    "Project Foreman": "FOREMAN",
    "Project Manager": "PM",
    "Pumper": "CRAFT",
    "QA Technician": "QUALITY",
    "QA/QC Assistant": "QUALITY",
    "QA/QC Manager": "QUALITY",
    "QA/QC Specialist": "QUALITY",
    "Quality Assurance Specialist": "QUALITY",
    "Quality Control Specialist": "QUALITY",
    "Quality Manager": "QUALITY",
    "Quality Specialist": "QUALITY",
    "Receiving & Document Controls": "ADMIN",
    "Regional Fleet Manager": "MANAGEMENT",
    "Regional Manager, Northern": "MANAGEMENT",
    "Regional Operations Manager": "MANAGEMENT",
    "Regional Project Manager": "PM",
    "Rig Foreman": "FOREMAN",
    "Rig Manager": "MANAGEMENT",
    "Rigger": "CRAFT",
    "Rigger - A": "CRAFT",
    "Safety Specialist": "HSE",
    "Senior Civil Designer": "ENGINEER",
    "Senior Designer": "ENGINEER",
    "Senior Estimating Manager": "ESTIMATION",
    "Senior HSE Specialist": "HSE",
    "Senior Journeyman": "CRAFT",
    "Senior Procurement Specialist": "PROCUREMENT",
    "Senior Project Admin Support S": "ADMIN",
    "Senior Project Coordinator": "PROJECT COORDINATOR",
    "Senior Project Estimator": "ESTIMATION",
    "Senior Project Manager": "PM",
    "Senior QA/QC Manager": "QUALITY",
    "Shipping & Receiving Manager": "PROCUREMENT",
    "Shipping/Receiving Specialist": "PROCUREMENT",
    "Ship & Receive Superintendent": "PROCUREMENT",
    "Shop Foreman": "CRAFT",
    "Skilled Labor": "CRAFT",
    "Spacer": "CRAFT",
    "Splicer I": "CRAFT",
    "Splicer II": "CRAFT",
    "Splicing Manager": "FOREMAN",
    "Spotter": "CRAFT",
    "Sr Director, Delta Directional": "MANAGEMENT",
    "Sr Director, Specialty Service": "MANAGEMENT",
    "Sr. Project Admin Support": "ADMIN",
    "Strawboss": "CRAFT",
    "Structural Fab Superintendent": "SUPERINTENDENT",
    "Superintendent": "SUPERINTENDENT",
    "Superintendent (Hourly)": "SUPERINTENDENT",
    "Superintendent (Salary)": "SUPERINTENDENT",
    "Surveyor": "CRAFT",
    "Technical Sales Manager": "MANAGEMENT",
    "Testing & Cleaning Tech II": "CRAFT",
    "Tie-In Foreman": "FOREMAN",
    "Truck Driver": "CRAFT",
    "Validation/Verification Coach": "CRAFT",
    "V&V Program Manager": "MANAGEMENT",
    "VP, Specialty Services & CPG": "MANAGEMENT",
    "Vice President": "MANAGEMENT",
    "Vice President, Region 2": "MANAGEMENT",
    "Welder - (w/o Rig)": "CRAFT",
    "Welder - Certified (w/o rig)": "CRAFT",
    "Welder - In Service": "CRAFT",
    "Welder Foreman": "FOREMAN",
    "Welding Foreman": "FOREMAN",
    "Welding Superintendent": "SUPERINTENDENT",
    "Yard Foreman": "FOREMAN",
    "Yard Manager": "MANAGEMENT",
    "Welder": "CRAFT",
    "Forman - Welding (w/o Rig)": "CRAFT",
    "Craftsman A": "CRAFT",
    "Document Controls Manager": "MANAGEMENT",
    "Piping Division Lead": "MANAGEMENT",
    "Civil & Structural Divi. Lead": "MANAGEMENT",
    "Applications Manager (PKT)": "MANAGEMENT",
    "Assembly Foreman": "FOREMAN",
    "Assembly Technician": "CRAFT",
    "Assembly Technician (PKT)": "CRAFT",
    "Assistant Superintendent (H)": "SUPERINTENDENT",
    "Assistant, Project Manager": "MANAGEMENT",
    "Billing and Inv Coor. II (PKT)": "ADMIN",
    "Billing and Inv Coordinator II": "ADMIN",
    "Blaster (PKT)": "CRAFT",
    "Common Labor (PKT)": "CRAFT",
    "Corrosion Supervisor": "FOREMAN",
    "Corrosion Technician I": "CRAFT",
    "Design Manager": "ENGINEER",
    "Designer II": "ENGINEER",
    "Designer IV": "ENGINEER",
    "Division Lead": "MANAGEMENT",
    "Doc Control Spec (PKT)": "ADMIN",
    "Doc Controls Manager (PKT)": "ADMIN",
    "Drill Foreman": "FOREMAN",
    "Electrical Journeyman I": "CRAFT",
    "Electrical Journeyman II": "CRAFT",
    "Engineering Manager (PKT)": "ENGINEER",
    "Equipment Operator (PKT)": "CRAFT",
    "Field Service Technician II": "CRAFT",
    "Foreman (HRLY) (PKT)": "FOREMAN",
    "HSE Coordinator": "HSE",
    "HSE Specialist I": "HSE",
    "HSE Specialist II": "HSE",
    "HSE Specialist III": "HSE",
    "Helper I": "CRAFT",
    "IE Apprentice (2nd Year) PKT": "CRAFT",
    "IE Apprentice (3rd Year) (PKT)": "CRAFT",
    "Instrument Technician (PKT)": "CRAFT",
    "Lead Electrical Engineer": "ENGINEER",
    "Lead HSE Specialist": "HSE",
    "Mechanical Drafter (PKT)": "ENGINEER",
    "Office Manager (PKT)": "ADMIN",
    "Operations Manager (PKT)": "MANAGEMENT",
    "Painter (PKT)": "CRAFT",
    "Project Admin Support Speciali": "ADMIN",
    "Project Director": "MANAGEMENT",
    "Project Manager (PKT)": "PM",
    "QA/QC Lead": "QUALITY",
    "Regional Manager": "MANAGEMENT",
    "Senior Designer (PKT)": "ENGINEER",
    "Ship/Rec Specialist (PKT)": "PROCUREMENT",
    "Ship/Rec Supervisor (PKT)": "PROCUREMENT",
    "Shipping/ Receiving Specialist": "PROCUREMENT",
    "Shipping/Receiving Supervisor": "PROCUREMENT",
    "Skilled Labor (PKT)": "CRAFT",
    "Sr. Equipment Operator-Crane": "CRAFT",
    "Sr. Mgr Operations (PKT)": "MANAGEMENT",
    "Sr. Program Manager": "MANAGEMENT",
    "Sr. Project Admin Spec (PKT)": "ADMIN",
    "Sr. QA Specialist (PKT)": "QUALITY",
    "Superintendent (Hourly) (PKT)": "SUPERINTENDENT",
    "Superintendent (Salary) (PKT)": "SUPERINTENDENT",
    "Warehouse Manager": "MANAGEMENT",
    "Warehouse Manager (PKT)": "MANAGEMENT",
    "Welder - (w/o Rig) (PKT)": "CRAFT",
    "Welding Foreman (PKT)": "FOREMAN"
}

const LaborClassificationTable = [
    { title: 'Employee_Title', description: 'EEO_Class_Description', newTitle: 'New_Title', header: true },
    { title: 'Assistant Division Manager', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Assistant Project Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Assistant Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Assistant Superintendent (S)', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Bending Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Bid Controls Specialist', description: 'Administrative Support', newTitle: 'ESTIMATION' },
    { title: 'Blaster', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Business Development Director', description: 'Executive Officials/Managers', newTitle: 'BD' },
    { title: 'Carpenter', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Civil Designer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Civil General Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Clerk', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Common Labor', description: 'Laborers and Helpers', newTitle: 'CRAFT' },
    { title: 'Construction Manager', description: '1st/Mid-Level Managers', newTitle: 'CM' },
    { title: 'Craft Helper', description: 'Laborers and Helpers', newTitle: 'CRAFT' },
    { title: 'Craftsman', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Crane Operator', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Designer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Director', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director & Gen. Manager, Delta', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director of Operations, WTX', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director of Quality Management', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Alternative Energy', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Bolt', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Bolt I&E Services', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Capital Facilities', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Delta Directional', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, EPC Services', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, East Texas', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Gen Manager, Pickett', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Gulf Coast Region', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, HSE', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Midcon Region', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Northern Region', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Pipeline Services', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Project Estimating', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Project Controls', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, South Texas', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Director, Southeastern Region', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Division Manager', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Document Controls Specialist', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Draftsman', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Driller', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'EHS Specialist', description: 'Professionals', newTitle: 'HSE' },
    { title: 'EPC Project Specialist', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Electrical Asst Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Electrical Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Electrical Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Electrical General Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Electrical Journeyman 1', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Electrical Journeyman 2', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Electrical Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Engineering Manager', description: '1st/Mid-Level Managers', newTitle: 'ENGINEER' },
    { title: 'Engineering Specialist', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Equipment Operator', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Estimating Manager', description: '1st/Mid-Level Managers', newTitle: 'ESTIMATION' },
    { title: 'Executive Assistant', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Fiber Division Administrator', description: '1st/Mid-Level Managers', newTitle: 'ADMIN' },
    { title: 'Fiber Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Fleet Logistic Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Fleet Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Foreman (Hourly)', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Foreman (Salary)', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Foreman - Welding (w/o Rig)', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'General Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'General Foreman (Hourly)', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'General Foreman (Salary)', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'General Manager', description: '1st/Mid-Level Managers', newTitle: 'CM' },
    { title: 'General Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'General Superintendent (H)', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'General Superintendent (S)', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'HSE & OQ Specialist', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE & OQ Specialist 1', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE & OQ Specialist 2', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Administrator', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Assistant', description: 'Administrative Support', newTitle: 'HSE' },
    { title: 'HSE Manager', description: '1st/Mid-Level Managers', newTitle: 'HSE' },
    { title: 'HSE Specialist', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Specialist 1', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Specialist 2', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Specialist 3', description: 'Professionals', newTitle: 'HSE' },
    { title: 'HSE Trainer', description: 'Professionals', newTitle: 'HSE' },
    { title: 'I&C Commissioning Technician', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'I&E Construction Manager', description: '1st/Mid-Level Managers', newTitle: 'CM' },
    { title: 'I&E Designer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'I&E Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'I&E Project Manager', description: '1st/Mid-Level Managers', newTitle: 'PM' },
    { title: 'I&E Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'IE Apprentice (1st Year)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'IE Apprentice (2nd Year)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'IE Apprentice (3rd Year)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'IE Apprentice (4th Year)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'IE Apprentice (5th Year)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Instrument Fitter', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Instrument Technician', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Intern', description: 'Administrative Support', newTitle: 'CRAFT' },
    { title: 'Journeyman', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Journeymen Electrician', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Junior Surveyor', description: 'Professionals', newTitle: 'CRAFT' },
    { title: 'Lead I&C Automation Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Lead Instrumentation Engineer', description: 'Technicians', newTitle: 'ENGINEER' },
    { title: 'Lead Mechanical Drafter', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Lead Structural Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Licensed Operator', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Line Locator', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Logistic Manager', description: '1st/Mid-Level Managers', newTitle: 'LOGISTICS' },
    { title: 'Manager', description: '1st/Mid-Level Managers', newTitle: 'ADMIN' },
    { title: 'Material Buyer/Expeditor', description: 'Administrative Support', newTitle: 'PROCUREMENT' },
    { title: 'Mechanic', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Mechanic Helper', description: 'Laborers and Helpers', newTitle: 'CRAFT' },
    { title: 'Mechanic Manager', description: '1st/Mid-Level Managers', newTitle: 'CRAFT' },
    { title: 'Mechanical Drafter', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Mechanical Drafting Lead', description: 'Technicians', newTitle: 'ENGINEER' },
    { title: 'Mechanical Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Office Manager', description: '1st/Mid-Level Managers', newTitle: 'ADMIN' },
    { title: 'Office Manager (Hourly)', description: '1st/Mid-Level Managers', newTitle: 'ADMIN' },
    { title: 'Operator', description: 'Equipment Operator', newTitle: 'CRAFT' },
    { title: 'OPERATOR I (Steward)', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Operator Helper', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Operations Manager', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Operations Manager, EPC', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Operations Supervisor', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Painter', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Payroll Manager', description: '1st/Mid-Level Managers', newTitle: 'ADMIN' },
    { title: 'Pipe Fitter', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Plant Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Process Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Procurement Manager', description: '1st/Mid-Level Managers', newTitle: 'PROCUREMENT' },
    { title: 'Procurement Specialist', description: 'Administrative Support', newTitle: 'PROCUREMENT' },
    { title: 'Production Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Program Manager', description: '1st/Mid-Level Managers', newTitle: 'PM' },
    { title: 'Project Admin Support', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Project Controls Manager', description: '1st/Mid-Level Managers', newTitle: 'PM' },
    { title: 'Project Controls Specialist', description: 'Administrative Support', newTitle: 'PM' },
    { title: 'Project Coordination Manager', description: '1st/Mid-Level Managers', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Coordinator', description: 'Professionals', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Controls Specialist', description: 'Administrative Support', newTitle: 'PM' },
    { title: 'Project Coordination Manager', description: '1st/Mid-Level Managers', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Coordinator', description: 'Professionals', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Coordinator (Hourly)', description: 'Professionals', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Coordinator (Salary)', description: 'Professionals', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Project Engineer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Project Estimator', description: 'Professionals', newTitle: 'ESTIMATION' },
    { title: 'Project Estimator, I&E', description: 'Professionals', newTitle: 'ESTIMATION' },
    { title: 'Project Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Project Manager', description: '1st/Mid-Level Managers', newTitle: 'PM' },
    { title: 'Pumper', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'QA Technician', description: 'Professionals', newTitle: 'QUALITY' },
    { title: 'QA/QC Assistant', description: 'Administrative Support', newTitle: 'QUALITY' },
    { title: 'QA/QC Manager', description: '1st/Mid-Level Managers', newTitle: 'QUALITY' },
    { title: 'QA/QC Specialist', description: 'Professionals', newTitle: 'QUALITY' },
    { title: 'Quality Assurance Specialist', description: 'Professionals', newTitle: 'QUALITY' },
    { title: 'Quality Control Specialist', description: 'Professionals', newTitle: 'QUALITY' },
    { title: 'Quality Manager', description: '1st/Mid-Level Managers', newTitle: 'QUALITY' },
    { title: 'Quality Specialist', description: 'Professionals', newTitle: 'QUALITY' },
    { title: 'Receiving & Document Controls', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Regional Fleet Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Regional Manager, Northern', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Regional Operations Manager', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Regional Project Manager', description: '1st/Mid-Level Managers', newTitle: 'PM' },
    { title: 'Rig Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Rig Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Rigger', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Rigger - A', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Safety Specialist', description: 'Professionals', newTitle: 'HSE' },
    { title: 'Senior Civil Designer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Senior Designer', description: 'Professionals', newTitle: 'ENGINEER' },
    { title: 'Senior Estimating Manager', description: '1st/Mid-Level Managers', newTitle: 'ESTIMATION' },
    { title: 'Senior HSE Specialist', description: 'Professionals', newTitle: 'HSE' },
    { title: 'Senior Journeyman', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Senior Procurement Specialist', description: 'Professionals', newTitle: 'PROCUREMENT' },
    { title: 'Senior Project Admin Support S', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Senior Project Coordinator', description: 'Professionals', newTitle: 'PROJECT COORDINATOR' },
    { title: 'Senior Project Estimator', description: 'Professionals', newTitle: 'ESTIMATION' },
    { title: 'Senior Project Manager', description: 'Executive Officials/Managers', newTitle: 'PM' },
    { title: 'Senior QA/QC Manager', description: '1st/Mid-Level Managers', newTitle: 'QUALITY' },
    { title: 'Shipping & Receiving Manager', description: '1st/Mid-Level Managers', newTitle: 'PROCUREMENT' },
    { title: 'Shipping/Receiving Specialist', description: 'Professionals', newTitle: 'PROCUREMENT' },
    { title: 'Ship & Receive Superintendent', description: '1st/Mid-Level Managers', newTitle: 'PROCUREMENT' },
    { title: 'Shop Foreman', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Skilled Labor', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Spacer', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Splicer I', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Splicer II', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Splicing Manager', description: '1st/Mid-Level Managers', newTitle: 'FOREMAN' },
    { title: 'Spotter', description: 'Laborers and Helpers', newTitle: 'CRAFT' },
    { title: 'Sr Director, Delta Directional', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Sr Director, Specialty Service', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Sr. Project Admin Support', description: 'Administrative Support', newTitle: 'ADMIN' },
    { title: 'Strawboss', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Structural Fab Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Superintendent (Hourly)', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Superintendent (Salary)', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Surveyor', description: 'Professionals', newTitle: 'CRAFT' },
    { title: 'Technical Sales Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Testing & Cleaning Tech II', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Tie-In Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Truck Driver', description: 'Operatives', newTitle: 'CRAFT' },
    { title: 'Validation/Verification Coach', description: 'Professionals', newTitle: 'CRAFT' },
    { title: 'V&V Program Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'VP, Specialty Services & CPG', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Vice President', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Vice President, Region 2', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Welder - (w/o Rig)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Welder - Certified (w/o rig)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Welder - In Service', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Welder Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Welding Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Welding Superintendent', description: '1st/Mid-Level Managers', newTitle: 'SUPERINTENDENT' },
    { title: 'Yard Foreman', description: 'Craft Workers', newTitle: 'FOREMAN' },
    { title: 'Yard Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Welder', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Forman - Welding (w/o Rig)', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Craftsman A', description: 'Craft Workers', newTitle: 'CRAFT' },
    { title: 'Document Controls Manager', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
    { title: 'Piping Division Lead', description: 'Executive Officials/Managers', newTitle: 'MANAGEMENT' },
    { title: 'Civil & Structural Divi. Lead', description: '1st/Mid-Level Managers', newTitle: 'MANAGEMENT' },
]

const ratioTable = [
    { title: 'Item', plan: 'Plan', jtd: 'JTD', dec: 'DEC', header: true },
    { title: 'Foreman : Craft Ratio', plan: '0:0', jtd: '1:489', dec: '0:0' },
    { title: 'Superintendent : Craft Ratio', plan: '0:0', jtd: '1:17', dec: '0:0' },
    { title: 'Percent Craft Overtime', plan: '0%', jtd: '14%', dec: '0%' },
    { title: 'Percent Super Overtime', plan: '0%', jtd: '0%', dec: '0%' },
    { title: 'Average Craft Base Wage Rate', plan: ' -  ', jtd: ' 28.97 ', dec: ' -   ' },
    { title: 'Average Supervision Base Wage Rate', plan: ' -  ', jtd: ' 89.31 ', dec: ' -   ' },
    { title: 'Percent Craft on Per Diem', plan: '0%', jtd: '100%', dec: '0%' },
    { title: 'Equipment Cost per Craft hour', plan: ' -  ', jtd: ' -  ', dec: ' -   ' },
    { title: 'Small Tools & Consumables per Craft Hour', plan: ' -  ', jtd: ' 5.48 ', dec: ' -   ' },
    { title: 'All-In Burn Rate (ST/OT/BD/BYOD/PD)', plan: ' -  ', jtd: ' 52.99 ', dec: ' -   ' }
]

const planVsActualTable = [
    { dataNeeded: 'Data Needed', plan: 'Plan', actualData: 'Actual Data', curMonth: 'Cur Month', classification: 'Classification', header: true },
    { dataNeeded: 'Super ST Hours', plan: '144', actualData: '-', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Super OT Hours', plan: '-', actualData: '-', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Total Super Hours', plan: '-', actualData: '144', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Super ST ', plan: '12,860', actualData: '-', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Super OT ', plan: '-', actualData: '-', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Total Super ', plan: '-', actualData: '12,860', classification: 'SUPERINTENDENT' },
    { dataNeeded: 'Foreman Total Hours', plan: '5', actualData: '-', classification: 'FOREMAN' },
    { dataNeeded: 'Craftsman ST ', plan: '60,631', actualData: '-', classification: 'CRAFT' },
    { dataNeeded: 'Craftsman OT ', plan: '15,363', actualData: '-', classification: 'CRAFT' },
    { dataNeeded: 'Total Craftsman ', plan: '-', actualData: '75,994', classification: 'CRAFT' },
    { dataNeeded: 'Craftsman ST Hours', plan: '2,093', actualData: '-', classification: 'CRAFT' },
    { dataNeeded: 'Craftsman OT Hours', plan: '354', actualData: '-', classification: 'CRAFT' },
    { dataNeeded: 'Total Craftsman Hours', plan: '-', actualData: '2,447', classification: 'CRAFT' },
    { dataNeeded: 'Count of Craftsman on PD', plan: '10', actualData: '0', classification: 'CRAFT' },
    { dataNeeded: 'Total Count of Craftsman', plan: '10', actualData: '0', classification: 'CRAFT' },
    { dataNeeded: 'Equipment ', plan: '-', actualData: '-', classification: '52100' },
    { dataNeeded: 'Small Tools ', plan: '13,411', actualData: '-', classification: '53300' },
    { dataNeeded: 'Current Month Name', plan: 'Dec', actualData: '-', curMonth: '-' },
    { dataNeeded: 'Current Month Start Date', plan: '12/1/23', actualData: '-', curMonth: '-' },
    { dataNeeded: 'Current Month End Date', plan: '12/31/23', actualData: '-', curMonth: '-' },
    { dataNeeded: 'Total Labor Hours', plan: '3,953', actualData: '-', curMonth: '-' },
    { dataNeeded: 'Total Labor \'s (ST/OT/BD/PD/BYOD)', plan: '209,455', actualData: '-', curMonth: '-' }
]

